import { formatDate } from "@angular/common";
import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { differenceInCalendarDays } from 'date-fns';
import * as moment from "moment";
import { NzModalService, NzNotificationService } from "ng-zorro-antd";
import { AddEditBookingModel, GetBranchByLocationModel, GetInformationBookingModel } from "../../models/booking-request.model";
import { BookingCheck } from "../../models/booking-response.model";
import { BookingService } from "../../services/booking.service";

@Component({
    selector: 'app-component-booking',
    templateUrl: './booking.component.html',
    styleUrls: ['./booking.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class BookingComponent implements OnInit, AfterContentChecked {
    provinces = [];
    districts = [];
    branches = [];
    productGroups = [];
    products = [];
    bookingTimes = [];
    bookingTimesAll = [];

    provinceId: number;
    districtId: number;
    branchCode: string;
    productGroupId: number;
    productId: number;
    bookingTimeId: number;
    bookingForm: FormGroup;
    isInput = true;
    outputBranch: string;
    outputProduct: string;
    outputCustomerName: string;
    outputBookingTimeName: string;
    outputDateBooking: string;
    outputBookingCode: string;
    imgQrCode: string;

    title = 'eFormClient';
    isMobile = window.innerWidth < 1000 ? true : false;
    current = 2;

    nzLoadingProvince = false;
    nzLoadingDistrict = false;
    nzLoadingBranch = false;
    nzLoadingBookingTime = false;
    nzLoadingProductGroup = false;
    nzLoadingProduct = false;
    isLoading = false;
    branchAddress: string;

    constructor(
        private bookingService: BookingService,
        private formBuilder: FormBuilder,
        private nzModal: NzModalService,
        private nzNotification: NzNotificationService,
        private cdref: ChangeDetectorRef
    ) { }

    ngOnInit() {
        this.getProvince();
        this.getBookingTimeList();

        let model = new GetBranchByLocationModel();
        this.getBranch(model);

        this.bookingForm = this.formBuilder.group({
            customerIdentity: null,
            customerName: null,
            phone: null,
            email: null,
            bookingDate: new Date,
            bookingTime: null,
            province: null,
            district: null,
            branch: null,
            productGroup: null,
            product: null,
            acceptTermsConditions: null,
        });
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    disabledDates(current: Date): boolean {
        let dateDiff = differenceInCalendarDays(current, new Date);
        return dateDiff > 6 || dateDiff < 0;
    }

    getProvince() {
        this.nzLoadingProvince = true;
        this.provinces = [];
        this.bookingService.getProvince().subscribe(
            res => {
                if (res) {
                    this.provinces = res.result.value.result;
                }
            },
            error => {
                this.nzNotification.error(
                    'ERROR',
                    error
                )
            },
            () => {
                this.nzLoadingProvince = false;
            }
        )
    }

    getBookingTimeList() {
        this.nzLoadingBookingTime = true;
        this.bookingTimes = [];
        this.bookingTimesAll = [];
        this.bookingService.getBookingTimesList().subscribe(
            res => {
                if (res) {
                    this.bookingTimes = res.result.value.result;
                    this.bookingTimesAll = this.bookingTimes;
                }
            },
            error => {
                this.nzNotification.error(
                    'ERROR',
                    error
                )
            },
            () => {
                this.nzLoadingBookingTime = false;
            }
        )
    }

    changeProvince() {
        this.nzLoadingDistrict = true;
        this.districts = [];
        this.branches = [];
        this.productGroups = [];
        this.products = [];
        this.provinceId = this.bookingForm.get('province').value;
        this.bookingService.getDistrictByProvinceId(this.provinceId).subscribe(
            res => {
                if (res) {
                    this.districts = res.result.value.result;
                }

                let model = new GetBranchByLocationModel();
                model.provinceId = this.provinceId;
                this.getBranch(model);

                this.bookingForm.get('district').setValue(null);
                this.bookingForm.get('branch').setValue(null);
                this.bookingForm.get('productGroup').setValue(null);
                this.bookingForm.get('product').setValue(null);
            },
            error => {
                this.nzNotification.error(
                    'ERROR',
                    error
                )
            },
            () => {
                this.nzLoadingDistrict = false;
            }
        )
    }

    changeDistrict() {
        this.districtId = this.bookingForm.get('district').value;

        if (this.districtId) {
            this.nzLoadingBranch = true;
            this.branches = [];
            this.productGroups = [];
            this.products = [];
            let model = new GetBranchByLocationModel();
            model.provinceId = this.provinceId;
            model.districtId = this.districtId;
            this.getBranch(model);
        }
    }

    getBranch(model: GetBranchByLocationModel) {
        this.branches = [];
        this.branchAddress = "";
        this.bookingService.getBranchByLocation(model).subscribe(
            res => {
                if (res) {
                    this.branches = res.result.value.result;
                }

                this.bookingForm.get('branch').setValue(null);
                this.bookingForm.get('productGroup').setValue(null);
                this.bookingForm.get('product').setValue(null);
            },
            error => {
                this.nzNotification.error(
                    'ERROR',
                    error
                )
            },
            () => {
                this.nzLoadingBranch = false;
            }
        )
    }

    changeBranch() {
        this.branchCode = this.bookingForm.get('branch').value;

        if (this.branchCode) {
            this.nzLoadingProductGroup = true;
            this.productGroups = [];
            this.products = [];
            let seletedBranch = this.branches.find(x => x.code == this.bookingForm.get('branch').value);
            if (seletedBranch) {
                this.branchAddress = seletedBranch.address;
            }
            this.bookingService.getProductGroups(this.branchCode).subscribe(
                res => {
                    if (res) {
                        this.productGroups = res.result.value.result;
                        let model = new GetInformationBookingModel();
                        model.bookingDate = this.bookingForm.get('bookingDate').value;
                        model.bookingTimeId = this.bookingTimeId;
                        model.branchCode = this.branchCode;
                        this.getInformationBooking(model);
                    }

                    this.bookingForm.get('productGroup').setValue(null);
                    this.bookingForm.get('product').setValue(null);
                },
                error => {
                    this.nzNotification.error(
                        'ERROR',
                        error
                    )
                },
                () => {
                    this.nzLoadingProductGroup = false;
                }
            )
        }

    }

    changeProductGroups() {
        this.productGroupId = this.bookingForm.get('productGroup').value;

        if (this.productGroupId) {
            this.nzLoadingProduct = true;
            this.products = [];
            this.bookingService.getProductsByProductGroupId(this.productGroupId).subscribe(
                res => {
                    if (res) {
                        this.products = res.result.value.result;
                    }

                    this.bookingForm.get('product').setValue(null);
                },
                error => {
                    this.nzNotification.error(
                        'ERROR',
                        error
                    )
                },
                () => {
                    this.nzLoadingProduct = false;
                }
            )
        }
    }

    changeProduct() {
        this.productId = this.bookingForm.get('product').value;
    }

    changeTime() {
        this.bookingTimeId = this.bookingForm.get('bookingTime').value;
        let model = new GetInformationBookingModel();
        model.bookingDate = this.bookingForm.get('bookingDate').value;
        model.bookingTimeId = this.bookingTimeId;
        model.branchCode = this.branchCode;
        this.getInformationBooking(model);
    }

    getInformationBooking(model: GetInformationBookingModel) {
        if (this.bookingForm.get('bookingDate').value
            && this.bookingTimeId && this.branchCode) {
            this.bookingService.getInformationBooking(model).subscribe(
                res => {
                    if (res) {
                        console.log(res["result"]);
                        var result = res.result.value.result;

                        if (res.result == null) {
                            this.nzNotification.error(
                                "ERROR",
                                "Lỗi : Chức năng lấy số lượng đặt hẹn bị lỗi! "
                            )
                            return;
                        }

                        if (result.isShowAlert) {
                            var branchName = this.branches.find(x => x.code = this.bookingForm.get('branch').value).name;
                            var bookingtimeName = this.bookingTimes.find(x => x.code = this.bookingForm.get('bookingTime').value).name;
                            var bookingDate = formatDate(this.bookingForm.get('bookingDate').value, 'yyyy/MM/dd', 'en-US');
                            this.nzNotification.warning(
                                "WARNING",
                                branchName + ' vào khung giờ ' + bookingtimeName + ' ngày ' + bookingDate +
                                ' đã có ' + result.value + ' khách hàng đặt hẹn giao dịch!'
                            )
                        }
                    }
                },
                error => {
                    this.nzNotification.error(
                        'ERROR',
                        error
                    )
                }
            )
        }
    }

    changeBookingDate(e) {
        // close
        if (!e) {
            let selectedDate = this.bookingForm.get('bookingDate').value as Date;
            if (selectedDate) {
                let dayOfWeek = selectedDate.getDay();
                this.bookingTimes = this.bookingTimesAll.filter(x => x.workDay.includes(dayOfWeek));
                let model = new GetInformationBookingModel();
                model.bookingDate = this.bookingForm.get('bookingDate').value;
                model.bookingTimeId = this.bookingTimeId;
                model.branchCode = this.branchCode;
                this.getInformationBooking(model);
            }
        }
    }

    submitForm() {
        if (!this.checkValid()) {
            return;
        }

        var formValue = this.bookingForm.value;
        var bookingModel = new AddEditBookingModel();

        bookingModel.id = 0;
        bookingModel.customerCode = "";
        bookingModel.customerIdentity = formValue.customerIdentity;
        bookingModel.customerName = formValue.customerName;
        bookingModel.phone = formValue.phone;
        bookingModel.email = formValue.email;
        bookingModel.dateOfBirth = null;
        bookingModel.address = "";
        bookingModel.branchCode = formValue.branch;
        bookingModel.bookingTimeId = formValue.bookingTime;
        bookingModel.bookingCode = "";
        bookingModel.bookingDate = formatDate(formValue.bookingDate, 'yyyy/MM/dd', 'en-US');
        bookingModel.status = 0;
        bookingModel.productId = formValue.product;
        bookingModel.productGroupId = formValue.productGroup;
        bookingModel.formCode = "";
        bookingModel.formData = null;
        bookingModel.bookingSource = "";
        bookingModel.acceptTermsConditions = formValue.acceptTermsConditions;
        this.isLoading = true;
        this.bookingService.checkBooking(bookingModel).subscribe(
            res => {
                var result = res.result.value.result;

                if (res.result == null) {
                    this.nzNotification.error(
                        "ERROR",
                        "Lỗi : Chức năng kiểm tra đặt hẹn bị lỗi! "
                    )
                }

                if (result.bookingCode == "ERR_BookingDate") {
                    this.nzNotification.error(
                        "ERROR",
                        "Lỗi : Thời gian đặt hẹn không hợp lệ! "
                    )
                }
                else if (result.bookingCode == "ERR_BookingTime") {
                    this.nzNotification.error(
                        "ERROR",
                        "Lỗi : Khung thời gian không hợp lệ! "
                    )
                    // }
                    // else if (result.bookingId == -1) {
                    //     var text = "Quý khách đã đặt hẹn vào lúc " + result.bookingTimeName + " ngày "
                    //         + formatDate(new Date(result.dateBooking), 'yyyy/MM/dd', 'en-US'); + ". Quý khách có muốn cập nhật lại thông tin đặt hẹn?";
                    //     this.nzModal.confirm({
                    //         nzTitle: 'Xác nhận',
                    //         nzContent: text,
                    //         nzOnOk: () => this.createBooking(bookingModel),
                    //     })
                }
                else if (result.bookingId == -1) {
                    this.createBooking(bookingModel)
                } else {
                    this.setOutput(result);
                }
            },
            error => {
                this.nzNotification.error(
                    'ERROR',
                    error
                )
            },
            () => {
                this.isLoading = false;
            }
        )
    }

    createBooking(bookingModel: AddEditBookingModel) {
        this.isLoading = true;
        this.bookingService.createBooking(bookingModel).subscribe(
            res => {
                if (res) {
                    var result = res.result.value.result;

                    if (res.result == null) {
                        this.nzNotification.error(
                            "ERROR",
                            "Lỗi : Chức năng kiểm tra đặt hẹn bị lỗi! "
                        )
                    }
                    if (result.bookingCode == "ERR_EmailTemplate") {
                        this.nzNotification.error(
                            "ERROR",
                            "Lỗi : Email template không đúng định dạng! "
                        )
                    } else if (result.bookingCode.substring(0, 2) == "B-" && result.bookingCode.length == 8) {
                        this.setOutput(result);
                    }
                }
            },
            err => {
                this.nzNotification.error(
                    'ERROR',
                    err
                )
            },
            () => {
                this.isLoading = false;
            }
        );
    }

    setOutput(result: BookingCheck) {
        let _product = result.productName != "" ? (" - " + result.productName) : "";
        this.isInput = false;
        this.urlTextQrCode(result.qrCode);
        this.outputBranch = result.branchName;
        this.outputProduct = result.productGroupName + _product;
        this.outputCustomerName = result.customerName;
        this.outputBookingTimeName = result.bookingTimeName;
        this.outputDateBooking = result.dateBooking;
        this.outputBookingCode = result.bookingCode;
    }

    checkValid(): boolean {
        if (!this.bookingForm.get('customerIdentity').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng nhập CCCD"
            )
            return false;
        }

        if (!this.bookingForm.get('customerName').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng nhập Họ tên"
            )
            return false;
        }

        if (!this.bookingForm.get('phone').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng nhập Số điện thoại"
            )
            return false;
        }

        if (!this.bookingForm.get('email').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng nhập Email"
            )
            return false;
        }

        if (!this.bookingForm.get('bookingDate').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng chọn ngày"
            )
            return false;
        }

        if (!this.bookingForm.get('bookingTime').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng chọn khung giờ"
            )
            return false;
        }

        if (!this.bookingForm.get('branch').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng chọn chi nhánh"
            )
            return false;
        }

        if (!this.bookingForm.get('productGroup').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng chọn nhóm dịch vụ"
            )
            return false;
        }

        if (!this.bookingForm.get('acceptTermsConditions').value) {
            this.nzNotification.warning(
                "WARNING",
                "Vui lòng chọn đồng ý chính sách SACOMBANK"
            )
            return false;
        }

        return true;
    }

    backToBooking() {
        this.isInput = true;
        this.imgQrCode = "";
        this.getProvince();
        this.getBookingTimeList();
        let model = new GetBranchByLocationModel();
        this.getBranch(model);
        this.bookingForm.reset();
        this.districts = [];
        this.branches = [];
        this.productGroups = [];
        this.products = [];
        this.bookingTimes = [];
        this.branchAddress = "";
    }

    urlTextQrCode(data: string) {
        if (data != "" && data != null) {
            if (data.length > 0 && data !== "-2" && data !== "-3") {
                this.imgQrCode = data;
            } else if (data === "-2") {
                this.nzNotification.warning(
                    "WARNING",
                    "Cảnh báo : License Aspose có lỗi! "
                )
            } else if (data === "-3") {
                this.nzNotification.warning(
                    "WARNING",
                    "Cảnh báo : Logo có lỗi!"
                )
            }
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.isMobile = window.innerWidth < 1000 ? true : false;
    }

    clickCB(event: any) {
        var block = document.getElementsByClassName('block-' + event.target.id);
        if (event.target.checked) {
            block[0].classList.remove('d-none');
        } else {
            block[0].classList.add('d-none');
        }
    }

    clickRadio(event: any) {
        var block = document.getElementsByClassName('block-' + event.target.id);
        if (event.target.checked) {
            block[0].classList.remove('d-none');
        } else {
            block[0].classList.add('d-none');
        }
    }

    checkTime(time: Date) {
        if (this.bookingForm.get('bookingDate').value) {
            let bookingDate = new Date(this.bookingForm.get('bookingDate').value);
            let current = new Date(time);
            let now = new Date;
            let nowWithoutDate = new Date(now.getTime()).setHours(0, 0, 0, 0);
            let nowAddHours = new Date(now.getTime()).setHours(now.getHours() + 1);

            return (differenceInCalendarDays(bookingDate.setHours(0, 0, 0, 0), nowWithoutDate) == 0
                && moment(current).format('HH:mm:ss') < moment(nowAddHours).format('HH:mm:ss'));
        }

        return false;
    }
}